export default __webpack_public_path__ + "static/media/icomoon.6c957433.svg";